<template>
  <v-btn id='corpolate-checkout' class="v-btn theme--light btn-big" @click="redirectToStripe()">登録する</v-btn>
</template>

<script>
  import { loadStripe } from '@stripe/stripe-js'
  import axios from 'axios'

  export default {
    props: [
      'stripeKey',
      'stripeProductId',
      'paymentMethodInput',
      'userIdInput',
      'emailsInput',
      'parentAttendInput',
      'isNeedConfirmDialog',
    ],

    data () {
      return {
        productId: this.stripeProductId,
        stripe: loadStripe(this.stripeKey),
        paymentMethod: this.paymentMethodInput,
        userId: this.userIdInput,
        emails: this.emailsInput,
        parent: this.parentAttendInput,
      }
    },

    methods: {
      disableButton () {
        const btn = document.getElementById('corpolate-checkout');
        if (btn) btn.disabled = true;
      },

      enableButton () {
        const btn = document.getElementById('corpolate-checkout');
        if (btn) btn.disabled = false;
      },
      async redirectToStripe () {
        // 個別コース受講者がいる場合、ダイアログを表示
        if (this.isNeedConfirmDialog === true || this.isNeedConfirmDialog === 'true') {
          const proceed = window.confirm('申込者もしくは招待ユーザーに個別コースを受講している方がいます。定額コースは個別コースの内容を含みます。登録してよろしいですか？');
          if (!proceed) {
            return;
          }
        }

        this.disableButton();
        // 銀行振り込みの場合通常の登録確認画面へ
        if (this.paymentMethod == 2) {
          const form = document.getElementById('corporate-plan-form');
          form.action = '/register/lb_corporate_subsc_plan/bank-confirm';
          form.method = 'post';
          form.submit();
          return;
        }

        try {
          const response = await axios.get('/api/create-lb-corporate-subsc-checkout-session', {
            params: {
            productId: this.productId,
            userId: this.userId,
            emails: this.emails,
            parent: this.parent
          }
          });

          const data = response.data;

          if (response.status !== 200 || !data || data.error) {
            this.enableButton();
            return;
          }

          if (!data.accessToken) {
            location.href = '/lb404';
            return;
          }

          const stripe = await loadStripe(this.stripeKey);
          await stripe.redirectToCheckout({ sessionId: data.sessionId });
        } catch (error) {
          this.enableButton();
          console.error(error);
        }
      }
    }
  }
</script>
